import { render } from "./CloneSkeleton.vue?vue&type=template&id=00696453&scoped=true"
import script from "./CloneSkeleton.vue?vue&type=script&lang=js"
export * from "./CloneSkeleton.vue?vue&type=script&lang=js"

import "./CloneSkeleton.vue?vue&type=style&index=0&id=00696453&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00696453"]])

export default __exports__